import React from "react";
import { Button, Flex } from "antd";
import CustomImage from "./CustomImage";

const CustomButton = ({
  text,
  onClick,
  width,
  minWidth,
  block,
  height,
  bgColor,
  color,
  fontSize,
  fontWeight,
  lineHeight,
  borderRadius,
  boxShadow,
  iconPosition,
  imageWidth,
  icon,
  paddingImage,
  image,
  marginTop,
  marginBottom,
  border,
  gap,
  padding,
  className,
  isFormValid = false,
  htmlType = "button",
}) => {
  return (
    <Button
      type="primary"
      disabled={isFormValid}
      htmlType={htmlType}
      onClick={onClick}
      block={block}
      className={className}
      style={{
        height: height,
        backgroundColor: isFormValid ? "#F5F5F5" : bgColor,
        color: isFormValid ? "#AFAFAF" : color,
        fontSize: fontSize,
        width: width,
        minWidth: minWidth,
        borderRadius: borderRadius,
        boxShadow: boxShadow,
        fontWeight: fontWeight,
        lineHeight: lineHeight,
        border: border || "none",
        padding: padding,
        marginTop: marginTop,
        marginBottom: marginBottom,
        cursor: isFormValid ? "not-allowed" : "pointer",
      }}
    >
      <Flex gap={gap} align="center">
        {/* Render icon or image on the left */}
        {iconPosition === "left" &&
          (image ? (
            <CustomImage width={imageWidth} src={image} preview={false}   style={{ opacity: isFormValid ? 0.3 : 1,padding: paddingImage}}  />
          ) : (
            icon
          ))}

        {/* Button text */}
        {text}

        {/* Render icon or image on the right */}
        {iconPosition === "right" &&
          (image ? (
            <CustomImage width={imageWidth} src={image} preview={false}   style={{ opacity: isFormValid ? 0.3 : 1 ,padding: paddingImage}}  />
          ) : (
            icon
          ))}
      </Flex>
    </Button>
  );
};

export default CustomButton;
